var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#clock_svg__a)",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.004 31.25c-5.73-.074-10.358-4.631-10.433-10.274.075-5.644 4.702-10.2 10.433-10.275 5.73.074 10.357 4.631 10.432 10.275-.075 5.643-4.702 10.2-10.433 10.274m0-18.266c-4.457.058-8.056 3.602-8.115 7.992.059 4.389 3.658 7.933 8.115 7.99 4.456-.057 8.055-3.601 8.114-7.99-.059-4.39-3.658-7.934-8.114-7.992m5.795 7.992c0 .63-.51 1.141-1.141 1.141h-5.814v-5.69a1.16 1.16 0 1 1 2.319 0v3.407h3.495c.63 0 1.141.511 1.141 1.142m1.16-9.792a1.15 1.15 0 0 1 1.61-1.64l1.849 1.814a1.15 1.15 0 1 1-1.61 1.64zm-17.377 1.81a1.15 1.15 0 0 1 0-1.64l1.826-1.805a1.152 1.152 0 0 1 1.62 1.639L11.2 12.993a1.15 1.15 0 0 1-1.619.002"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clock_svg__a",
    x1: 40,
    x2: -5.046,
    y1: 43.125,
    y2: 31.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C4579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525252"
  })))));
};
export default SvgClock;